import {defineStore} from 'pinia'
import {CommonNs} from "@shared/types";
import {MarketNs} from "@shared/types/marketplace.namespace";
import {MarketApi} from "@/api/marketplace.apis";


export const useMarketStore = defineStore("market", {
  state: () => ({}),
  getters: {},
  actions: {
    async importProject(
        payload: MarketNs.ImportProjectRequest): Promise<CommonNs.AnyResponse> {
      return MarketApi.importProject(payload).then((response) => response)
    }
  }
})
